var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    transform: "translate(-1192 -374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_111",
    className: "no-fill stroke",
    "data-name": "Ellipse 111",
    transform: "translate(1194 374)",
    fill: "none",
    stroke: "#58299c",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    stroke: "none",
    className: "no-stroke"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 9,
    fill: "none",
    className: "no-fill"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fill",
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M0,8C0,3.582,6.044,0,13.5,0S27,3.582,27,8Z",
    transform: "translate(1192 393)",
    fill: "#58299c"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fill",
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(1202 382)",
    fill: "#58299c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.aef2dc83.svg";
export { ForwardRef as ReactComponent };